"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _events = _interopRequireDefault(require("../utils/events"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ClickOutside = (0, _react.memo)(({
  className = null,
  onClick = () => {},
  style = {},
  onClickOutside,
  children = null,
  reference
}) => {
  const containerRef = (0, _react.useRef)(null);
  const referenceElement = (0, _react.useRef)(reference);
  (0, _react.useEffect)(() => {
    let isTouch;
    const handle = event => {
      if (event.type === 'touchend') isTouch = true;
      if (event.type === 'click' && isTouch) return;
      const element = containerRef.current;
      const referenceEl = referenceElement.current;
      if (referenceEl && referenceEl !== null && referenceEl !== void 0 && referenceEl.contains(event.target)) {
        return;
      }
      if (element && !element.contains(event.target)) {
        onClickOutside(event);
      }
    };
    _events.default.on(document, 'touchend', handle, true);
    _events.default.on(document, 'click', handle, true);
    return () => {
      _events.default.off(document, 'touchend', handle, true);
      _events.default.off(document, 'click', handle, true);
    };
  }, [containerRef, reference, onClickOutside]);
  return _react.default.createElement("div", {
    className: className,
    onClick: onClick,
    ref: containerRef,
    style: style
  }, children);
});
var _default = exports.default = ClickOutside;